import db from '@/db'
import moment from 'moment-timezone'

const modules = {};

const initState = {
    loading: false,
    active: []
};

const state = () => {
    return Object.assign({}, initState)
};
const getters = {
    db() {
        return db.firestore.checkouts
    }
};
const mutations = {
    active(state, value) {
        state.active = Array.from(value)
    },
    loading(state, value) {
        state.loading = !!value
    }
};

const actions = {
    load({state, commit, dispatch}, payload) {
        if (state.loadingCheckouts) {
            return Promise.reject('Already loading checkouts')
        }
        commit('loading', true)
        return dispatch('get', payload)
            .then((checkouts:Array<object>) => {
                commit('active', checkouts)
                commit('loading', false)
                return checkouts
            })
            .catch((error) => {
                commit('loading', false)
            })
    },
    get({getters}, payload=null) {
        return getters['db']
            .where('in', '==', null)
            .orderBy("out", "desc")
            .orderBy("to", "asc")
            .get()
            .then((snapshot:any) => {
                const checkouts:Array<object> = [];
                snapshot.forEach((checkout) => {
                    // console.log("TYPE", typeof(checkout));
                    const data = checkout.data();
                    data.id = checkout.id;
                    data.out = moment(data.out.toMillis());
                    checkouts.push(data)
                })
                return checkouts
            })
            .catch((error) => {
                console.error(error)
            })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules
}
